import { Notify, type QNotifyOptions } from 'quasar';

const feedback = {
  positive: (message?: string, options?: QNotifyOptions): void => {
    Notify.create({
      color: 'positive',
      message: message || 'Sucesso!',
      timeout: 5000,
      ...options,
    });
  },

  negative: (message?: string, options?: QNotifyOptions): void => {
    Notify.create({
      color: 'negative',
      message: message || 'Aconteceu algum erro, tente novamente mais tarde',
      timeout: 5000,
      ...options,
    });
  },
};

export default feedback;
